/* Cart drawer on every page (his asks Oct 16 2026):
   1. The list stays exactly where the customer is. The theme rebuilds the drawer after every cart
      change (cart.js onCartRefresh sets innerHTML), which puts a NEW list at the top. We always know
      which row the customer is looking at (updated on every scroll, and again right when a refresh
      starts), and put that row back on the same spot of the screen the moment the new list arrives,
      before the screen paints. No timers, no guessing from touches.
   2. "+ Add" in the Finish the set box: green "Added", the row fades out (his pick A, faster),
      then the real add runs (ecc-cart-extras.js). */
(function () {
  var cur = null, snap = null, guardUntil = 0, touching = false;

  function drawerEl() { return document.getElementById('CartDrawer'); }
  function isOpen() { var d = drawerEl(); return !!(d && d.hasAttribute('open')); }
  function canScroll(el) { return el && el.offsetParent !== null && el.scrollHeight > el.clientHeight + 1; }
  /* the element that really scrolls: the theme's list box, or (some phones) whatever box inside the drawer scrolls */
  function findBox() {
    var d = drawerEl(); if (!d) return null;
    var all = d.querySelectorAll('.drawer__scrollable');
    for (var i = 0; i < all.length; i++) { if (canScroll(all[i])) return all[i]; }
    var els = d.querySelectorAll('.drawer__inner, .drawer__content, .drawer__panel, .drawer__scrollable, [class*="scroll"]');
    for (var j = 0; j < els.length; j++) { var cs = getComputedStyle(els[j]); if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && canScroll(els[j])) return els[j]; }
    for (var k = 0; k < all.length; k++) { if (all[k].offsetParent !== null) return all[k]; }
    return null;
  }
  function box() { if (cur && cur.isConnected && canScroll(cur)) return cur; cur = findBox(); return cur; }
  function rowOf(btn) { return (btn.closest && btn.closest('.ecc2-arow, [data-ecc-card]')) || btn; }
  function shown(el) { var r = el.getBoundingClientRect(); return r.height > 1 && getComputedStyle(el).opacity !== '0'; }

  /* remember what the customer sees: the first row (with a + Add) that is on screen */
  function takeSnap() {
    var b = box(); if (!b || !isOpen()) return;
    var bt = b.getBoundingClientRect(), a = null;
    var btns = b.querySelectorAll('[data-ecc-add][data-vid]:not([data-ecc-qvadd])');
    for (var i = 0; i < btns.length; i++) {
      var row = rowOf(btns[i]), r = row.getBoundingClientRect();
      if (shown(row) && r.bottom > bt.top + 1 && r.top < bt.bottom) { a = btns[i]; break; }
    }
    snap = { vid: a ? a.getAttribute('data-vid') : null, off: a ? rowOf(a).getBoundingClientRect().top - bt.top : 0, top: b.scrollTop };
  }
  /* put it back */
  function restore() {
    var b = box(); if (!b || !snap) return;
    b.style.scrollBehavior = 'auto';
    var bt = b.getBoundingClientRect();
    var el = snap.vid ? b.querySelector('[data-ecc-add][data-vid="' + snap.vid + '"]:not([data-ecc-qvadd])') : null;
    if (el && shown(rowOf(el))) {
      var d = (rowOf(el).getBoundingClientRect().top - bt.top) - snap.off;
      if (Math.abs(d) > 1) b.scrollTop += d;
    } else if (Math.abs(b.scrollTop - snap.top) > 1) {
      b.scrollTop = snap.top;
    }
  }

  /* anything inside the drawer changed: if the list was rebuilt, put the customer's row back in the same
     tick (before paint); if only part changed, the same alignment is a no-op when nothing moved */
  function onSwap() {
    if (!isOpen()) { snap = null; cur = null; return; }
    var old = cur, b = box();
    if (!b || !snap || snap.top < 2) return;
    restore();
    if (b !== old) {
      guardUntil = Date.now() + 900;
      requestAnimationFrame(restore);
      setTimeout(function () { if (!touching) restore(); }, 120);
    }
  }
  function watch() {
    var d = drawerEl(); if (!d || d.__ecKeep) return; d.__ecKeep = true;
    new MutationObserver(onSwap).observe(d, { childList: true, subtree: true });
    new MutationObserver(function () { if (!d.hasAttribute('open')) { snap = null; cur = null; } }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  /* keep the snapshot fresh while the customer scrolls; right after a rebuild, undo any jump the theme makes */
  document.addEventListener('scroll', function (e) {
    if (!isOpen()) return;
    var b = box(); if (!b || e.target !== b) return;
    if (Date.now() < guardUntil && !touching) { restore(); return; }
    takeSnap();
  }, true);
  document.addEventListener('touchstart', function () { touching = true; guardUntil = 0; }, { passive: true, capture: true });
  document.addEventListener('touchend', function () { touching = false; }, { passive: true, capture: true });
  document.addEventListener('wheel', function () { guardUntil = 0; }, { passive: true, capture: true });
  /* a refresh is about to start: this is exactly what the customer is looking at */
  document.addEventListener('cart:refresh', takeSnap, true);

  /* "+ Add": green Added, fade the row, then the real add */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer [data-ecc-add]');
    if (!btn || btn.hasAttribute('data-ecc-qvadd') || btn.__ecGo) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.__ecWait) return; btn.__ecWait = true;
    btn.style.cssText += ';background:#12876f !important;border-color:#12876f !important;color:#fff !important;transition:background .15s,color .15s';
    btn.textContent = '✓ Added';
    var row = btn.closest('.ecc2-arow');
    setTimeout(function () {
      if (row) { row.style.maxHeight = row.offsetHeight + 'px'; row.style.overflow = 'hidden'; row.style.transition = 'opacity .25s, max-height .25s'; void row.offsetHeight; row.style.opacity = '0'; row.style.maxHeight = '0'; }
      setTimeout(function () { btn.__ecGo = true; takeSnap(); btn.click(); }, row ? 260 : 0);
    }, 800);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
